const UkFlagIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="UK">
            <g clipPath="url(#clip0_1172_1402)">
                <g id="Group">
                    <g id="Group_2">
                        <path
                            id="Vector"
                            d="M13.9974 5.77403H7.8346V0.182495H6.15236V5.77403H0.00585938V8.56826H6.15236V14.1575H7.8346V8.56826H13.9974V5.77403Z"
                            fill="#CE1124"
                        />
                    </g>
                    <g id="Group_3">
                        <path id="Vector_2" d="M0 1.80908V4.85204H3.0528L0 1.80908Z" fill="#00247D" />
                        <path
                            id="Vector_3"
                            d="M1.68438 0.180969L1.63965 0.184823L5.59805 4.15137V0.180969H1.68438Z"
                            fill="#00247D"
                        />
                        <path
                            id="Vector_4"
                            d="M4.69791 4.83279L0 0.181763V1.278L3.57844 4.83279H4.69791Z"
                            fill="#CE1124"
                        />
                        <path
                            id="Vector_5"
                            d="M9.30176 9.50513L13.9997 14.1562V13.0599L10.4212 9.50513H9.30176Z"
                            fill="#CE1124"
                        />
                    </g>
                    <g id="Group_4">
                        <path id="Vector_6" d="M0 12.5523V9.50934H3.0528L0 12.5523Z" fill="#00247D" />
                        <path
                            id="Vector_7"
                            d="M1.68438 14.1803L1.63965 14.1765L5.59805 10.21V14.1803H1.68438Z"
                            fill="#00247D"
                        />
                        <path
                            id="Vector_8"
                            d="M4.67374 9.50482L0.00292969 14.1538L1.0953 14.1558L5.60222 9.69389V9.50482H4.67374Z"
                            fill="#CE1124"
                        />
                    </g>
                    <g id="Group_5">
                        <path id="Vector_9" d="M14.0001 1.80841V4.85136H10.9473L14.0001 1.80841Z" fill="#00247D" />
                        <path
                            id="Vector_10"
                            d="M12.316 0.180359L12.3607 0.184199L8.40234 4.15073V0.180359H12.316Z"
                            fill="#00247D"
                        />
                        <path
                            id="Vector_11"
                            d="M13.9956 0.186867L12.9449 0.186707L8.40625 4.68009V4.83773H9.36649L13.9956 0.186867Z"
                            fill="#CE1124"
                        />
                    </g>
                    <g id="Group_6">
                        <path id="Vector_12" d="M14.0001 12.5512V9.50818H10.9473L14.0001 12.5512Z" fill="#00247D" />
                        <path
                            id="Vector_13"
                            d="M12.316 14.1792L12.3607 14.1753L8.40234 10.2088V14.1792H12.316Z"
                            fill="#00247D"
                        />
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1172_1402">
                <rect y="0.180359" width="14" height="14" rx="5.25" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default UkFlagIcon;
